module.exports = __webpack_public_path__ + "img/img_card03.80ff48b9.png";